// Queries
import PAGINATED_REVIEWS from '@/assets/graphql/queries/reviews/PaginatedReviews.graphql';
import REVIEWS_ACTIVITIES from '@/assets/graphql/queries/reviews/ReviewsActivities.graphql';
import REVIEWS_INFORMATION from '@/assets/graphql/queries/reviews/ReviewsInformation.graphql';

// Mutations
import CREATE_ANSWER from '@/assets/graphql/mutations/reviews/CreateAnswer.graphql';
import UPDATE_ANSWER from '@/assets/graphql/mutations/reviews/UpdateAnswer.graphql';
import DELETE_ANSWER from '@/assets/graphql/mutations/reviews/DeleteAnswer.graphql';

// service
import apolloService from '@/services/apolloService';
import { axiosApi } from '@/config/http';
import * as Types from './types';
import type { ApiResponse } from '@/config/http/types';

export default class {
  // QUERIES
  static getPaginatedReviews(variables: Types.PaginatedReviewsPayload) {
    return apolloService.query<Types.PaginatedReviewsResponse>(
      PAGINATED_REVIEWS,
      variables,
      {
        fetchPolicy: 'network-only',
      },
    );
  }
  static getPartnerReviewsActivities() {
    return apolloService.query<Types.PartnersReviewsActivityResponse>(
      REVIEWS_ACTIVITIES,
      undefined,
      {
        fetchPolicy: 'network-only',
      },
    );
  }
  static getPartnerReviewsInformation() {
    return apolloService.query<Types.PartnersReviewsInformationResponse>(
      REVIEWS_INFORMATION,
      undefined,
      {
        fetchPolicy: 'network-only',
      },
    );
  }

  // MUTATIONS
  static createAnswer(variables: Types.CreateAnswerPayload) {
    return apolloService.mutate<Types.CreateAnswerResponse>(
      CREATE_ANSWER,
      variables,
    );
  }

  static updateAnswer(variables: Types.UpdateAnswerPayload) {
    return apolloService.mutate<Types.UpdateAnswerResponse>(
      UPDATE_ANSWER,
      variables,
    );
  }

  static deleteAnswer(variables: Types.DeleteAnswerPayload) {
    return apolloService.mutate<Types.DeleteAnswerResponse>(
      DELETE_ANSWER,
      variables,
    );
  }

  // API CALLS
  static async generateAIReviewSummary(activityId: string) {
    try {
      const response = await axiosApi.post<
        ApiResponse<Types.GenerateAIReviewSummaryResponse>
      >('/v1/reviews/generate', {
        activity_id: activityId,
      });
      return {
        response: response.data.response,
        status: response.status,
      };
    } catch (error: any) {
      throw error.response.data;
    }
  }
}
